var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bold-a{isolation:isolate;}.bold-b{fill:#484848;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bold-a",
    transform: "translate(-547.701 -1205.028)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bold-b",
    d: "M554.7,1221.66v-9.282a1.223,1.223,0,0,1,1.348-1.35h4.964c2.284,0,3.454,1.458,3.454,3.06a2.667,2.667,0,0,1-2.07,2.753,2.909,2.909,0,0,1,2.3,2.95,3.16,3.16,0,0,1-3.49,3.237h-5.162A1.228,1.228,0,0,1,554.7,1221.66Zm5.755-5.81a1.325,1.325,0,1,0,0-2.645h-3.2v2.645Zm.089,5a1.379,1.379,0,0,0,1.547-1.422,1.4,1.4,0,0,0-1.547-1.4h-3.291v2.826Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldIcon);
export default __webpack_public_path__ + "static/media/boldIcon.5c52f6d463c1d88e8b57384a2c054e93.svg";
export { ForwardRef as ReactComponent };